import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  PAYMENT_REQUEST_LIST,
  PAYMENT_REQUEST_PREVIEW,
  PAYMENT_REQUEST_PREDICTED,
  PAYMENT_REQUEST_UNCOLLECTABLE,
  PAYMENT_REQUEST_DATA,
  PAYMENT_REQUEST_CREATE,
  PAYMENT_REQUEST_SEARCH,
  PAYMENT_REQUEST_VOID,
} from "./actionType";

import {
  paymentRequestListSuccess,
  paymentRequestListFail,
  paymentRequestPreviewSuccess,
  paymentRequestPreviewFail,
  paymentRequestPredictedSuccess,
  paymentRequestPredictedFail,
  paymentRequestUncollectableSuccess,
  paymentRequestUncollectableFail,
  paymentRequestDataSuccess,
  paymentRequestDataFail,
  paymentRequestCreateSuccess,
  paymentRequestCreateFail,
  paymentRequestSearchSuccess,
  paymentRequestSearchFail,
  paymentRequestVoidSuccess,
  paymentRequestVoidFail,
} from "./action";

import {
  getPaymentRequestList,
  getPaymentRequestPreview,
  getPaymentRequestPredicted,
  getPaymentRequestUncollectable,
  getPaymentRequestData,
  createPaymentRequest,
  searchPaymentRequest,
  voidPaymentRequest,
} from "../../helpers/fakebackend_helper";

//PAYMENT_REQUEST_LIST
function* handlePaymentRequestList({ payload }) {
  try {
    const response = yield call(getPaymentRequestList, payload);
    yield put(paymentRequestListSuccess(response));
  } catch (error) {
    yield put(paymentRequestListFail(error));
  }
}
//worker saga
function* watchPaymentRequestList() {
  yield takeEvery(PAYMENT_REQUEST_LIST, handlePaymentRequestList);
}
//PAYMENT_REQUEST_PREVIEW
function* handlePaymentRequestPreview({ payload }) {
  try {
    const response = yield call(getPaymentRequestPreview, payload);
    yield put(paymentRequestPreviewSuccess(response));
  } catch (error) {
    yield put(paymentRequestPreviewFail(error));
  }
}
//worker saga
function* watchPaymentRequestPreview() {
  yield takeEvery(PAYMENT_REQUEST_PREVIEW, handlePaymentRequestPreview);
}
//PAYMENT_REQUEST_PREDICTED
function* handlePaymentRequestPredicted({ payload }) {
  try {
    const response = yield call(getPaymentRequestPredicted, payload);
    yield put(paymentRequestPredictedSuccess(response));
  } catch (error) {
    yield put(paymentRequestPredictedFail(error));
  }
}
//worker saga
function* watchPaymentRequestPredicted() {
  yield takeEvery(PAYMENT_REQUEST_PREDICTED, handlePaymentRequestPredicted);
}
//PAYMENT_REQUEST_UNCOLLECTABLE
function* handlePaymentRequestUncollectable({ payload }) {
  try {
    const response = yield call(getPaymentRequestUncollectable, payload);
    yield put(paymentRequestUncollectableSuccess(response));
  } catch (error) {
    yield put(paymentRequestUncollectableFail(error));
  }
}
//worker saga
function* watchPaymentRequestUncollectable() {
  yield takeEvery(PAYMENT_REQUEST_UNCOLLECTABLE, handlePaymentRequestUncollectable);
}
//PAYMENT_REQUEST_DATA
function* handlePaymentRequestData({ payload }) {
  try {
    const response = yield call(getPaymentRequestData, payload);
    yield put(paymentRequestDataSuccess(response));
  } catch (error) {
    yield put(paymentRequestDataFail(error));
  }
}
//worker saga
function* watchPaymentRequestData() {
  yield takeEvery(PAYMENT_REQUEST_DATA, handlePaymentRequestData);
}
//PAYMENT_REQUEST_CREATE
function* handlePaymentRequestCreate({ payload }) {
  try {
    const response = yield call(createPaymentRequest, payload);
    yield put(paymentRequestCreateSuccess(response));
  } catch (error) {
    yield put(paymentRequestCreateFail(error));
  }
}
//worker saga
function* watchPaymentRequestCreate() {
  yield takeEvery(PAYMENT_REQUEST_CREATE, handlePaymentRequestCreate);
}
//PAYMENT_REQUEST_SEARCH
function* handlePaymentRequestSearch({ payload }) {
  try {
    const response = yield call(searchPaymentRequest, payload);
    yield put(paymentRequestSearchSuccess(response));
  } catch (error) {
    yield put(paymentRequestSearchFail(error));
  }
}
//worker saga
function* watchPaymentRequestSearch() {
  yield takeEvery(PAYMENT_REQUEST_SEARCH, handlePaymentRequestSearch);
}
//PAYMENT_REQUEST_VOID
function* handlePaymentRequestVoid({ payload }) {
  try {
    const response = yield call(voidPaymentRequest, payload);
    yield put(paymentRequestVoidSuccess(response));
  } catch (error) {
    yield put(paymentRequestVoidFail(error));
  }
}
//worker saga
function* watchPaymentRequestVoid() {
  yield takeEvery(PAYMENT_REQUEST_VOID, handlePaymentRequestVoid);
}
//root saga
export default function* PaymentRequest() {
  yield all([
    watchPaymentRequestList(),
    watchPaymentRequestPreview(),
    watchPaymentRequestPredicted(),
    watchPaymentRequestUncollectable(),
    watchPaymentRequestData(),
    watchPaymentRequestCreate(),
    watchPaymentRequestSearch(),
    watchPaymentRequestVoid(),
  ]);
}
